import {
  TOGGLE_NECKLACE_MODAL,
  TOGGLE_MEMORY_MODAL,
  CLOSE_NECKLACE_MODALS,
  FETCH_CONFIGURATOR_PAGE_NECKLACE_FIELDS,
  SELECT_ACTIVE_MEMORY_IN_MODAL,
  TOGGLE_SHOW_EDIT_MEMORY_IN_MODAL,
  UPDATE_ACTIVE_MEMORY_ENGRAVING,
  TOGGLE_MEMORY_MODAL_WITH_MEMORY,
} from "./types";

import ContentfulApi from "../../lib/ContentfulApi";

export const fetchConfiguratorPageNecklaceFields = () => {
  return (dispatch) => {
    const api = new ContentfulApi();

    api
      .getConfiguratorPageNecklaceFields()
      .then((response) => {
        dispatch({
          type: FETCH_CONFIGURATOR_PAGE_NECKLACE_FIELDS,
          payload: response,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };
};

export const toggleNecklaceSelectModal = (type = "necklace", index = 0) => {
  return (dispatch, getState) => {
    if (type === "necklace") {
      dispatch({
        type: TOGGLE_NECKLACE_MODAL,
      });
    } else {
      const activeMemories = getState().necklace.activeMemories;
      if (activeMemories && activeMemories.length) {
        let foundActiveMemory = false;
        for (let i = 0; i < activeMemories.length; i++) {
          if (activeMemories[i].index === index) {
            dispatch({
              type: TOGGLE_MEMORY_MODAL_WITH_MEMORY,
              memory: activeMemories[i].memory,
              engraving: activeMemories[i].engraving,
              index,
            });
            foundActiveMemory = true;
          }
        }
        if (!foundActiveMemory) {
          dispatch({
            type: TOGGLE_MEMORY_MODAL,
            payload: index,
          });
        }
      } else {
        dispatch({
          type: TOGGLE_MEMORY_MODAL,
          payload: index,
        });
      }
    }
  };
};

export const closeNecklaceSelectModals = () => {
  return (dispatch) => {
    dispatch({
      type: CLOSE_NECKLACE_MODALS,
    });
    dispatch({
      type: TOGGLE_SHOW_EDIT_MEMORY_IN_MODAL,
      payload: false,
    });
  };
};

export const selectActiveMemoryInModal = (memoryItem, index, material) => {
  return (dispatch) => {
    dispatch({
      type: SELECT_ACTIVE_MEMORY_IN_MODAL,
      payload: {
        memory: memoryItem,
        index: index,
        material: material,
      },
    });
    dispatch({
      type: TOGGLE_SHOW_EDIT_MEMORY_IN_MODAL,
      payload: true,
    });
  };
};

export const updateActiveMemoryEngraving = (text) => {
  return (dispatch) => {
    dispatch({
      type: UPDATE_ACTIVE_MEMORY_ENGRAVING,
      payload: text,
    });
  };
};

export const toggleShowEditMemoryInModal = (value = true) => {
  return (dispatch) => {
    dispatch({
      type: TOGGLE_SHOW_EDIT_MEMORY_IN_MODAL,
      payload: value,
    });
  };
};
